/*链接参数操作相关工具函数*/
import { getQueryString } from './url'
import { getSessionVal } from './storage'

export function getUnionId() {
  try {
    return window.wxUtil.getUnionId()
  } catch (err) {
    console.log('err>>', err)
  }
  let userInfo =
    (getQueryString('userInfo') &&
      JSON.parse(decodeURIComponent(getQueryString('userInfo')))) ||
    {}
  return (
    userInfo.unionId ||
    getQueryString('unionId') ||
    getSessionVal('unionId') ||
    ''
  )
}

export function getOpenId() {
  try {
    return window.wxUtil.getOpenId()
  } catch (err) {
    console.log('err>>', err)
  }
  return (
    getQueryString('openid') ||
    getQueryString('openId') ||
    getQueryString('mpOpenId') ||
    getSessionVal('openId') ||
    ''
  )
}
